import React, { useState } from 'react'
import BankPayments from './components/BankPayments'

const Payments = () => {
  
  return (
    <div>
        <BankPayments/>
    </div>
  )
}

export default Payments